/*
 * @Author: <pcjser> 
 * @Date: 2018-04-19 09:12:44 
 * @Last Modified by: pcjser
 * @Last Modified time: 2018-06-06 11:35:10
 */
import React, {
  Component
} from 'react';
import { APIShare } from './service/fetch';
import Routes from './route.jsx';

import './assets/flexible';

class App extends Component {
  async componentWillMount() {
    const platform = window.localStorage.getItem('fw-platform')
    if (platform !== 'fengwanI') {
      const params = await APIShare({ url: window.location.href.split("#")[0] });
      if (params.code === 200) {
        window.wx.config({
          debug: false,
          appId: params.payload.appId, // 必填，公众号的唯一标识
          timestamp: params.payload.timestamp, // 必填，生成签名的时间戳
          nonceStr: params.payload.nonceStr, // 必填，生成签名的随机串
          signature: params.payload.signature, // 必填，签名，见附录1
          jsApiList: [
            'checkJsApi', //判断当前客户端版本是否支持指定JS接口
            'onMenuShareTimeline', //分享给好友
            'onMenuShareAppMessage', //分享到朋友圈
            'onMenuShareQQ' //分享到QQ
          ]
        });
      } else {
        console.log('分享出错!')
      }
      let image = ''
      let title = ''
      if (window.location.href.indexOf('anfeng') > -1) {
        title = '安锋游戏贵宾中心，诚挚为您服务'
        image = 'https://i.anfeng.com/fengwan/share-logo.jpg';
      } else {
        title = '意游贵宾中心，诚挚为您服务'
        image = 'https://i.mowowo.com/fengwan/share-yy.jpg';
      }
      const resolve = () => {
        window.wx.onMenuShareTimeline({ //分享到朋友圈
          title: title,
          desc: "享受生活，享受游戏，享受非凡客服体验", // 分享描述
          link: window.location.href,
          imgUrl: image,
          success: () => {
            console.log("分享成功");
          }
        });

        window.wx.onMenuShareAppMessage({ //分享到朋友
          title: title, // 分享标题
          desc: "享受生活，享受游戏，享受非凡客服体验", // 分享描述
          link: window.location.href, // 分享链接
          imgUrl: image, // 分享图标
          success: () => {
            console.log("分享成功");
          }
        });
      }
      window.wx.ready(resolve);
    }
  }
  render() {
    return (
      <div className="App">
        <Routes></Routes>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx